import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { AttachmentsResponseData, removeAttachmentOwnerReference } from '../query-api'

interface UseRemoveAttachmentOwnerReferenceProps {
  onError?: (error?: APIError) => void
  onSuccess?: (response: AttachmentsResponseData) => void
}

export const useRemoveAttachmentOwnerReference = (props?: UseRemoveAttachmentOwnerReferenceProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: remove, ...rest } = useMutation(removeAttachmentOwnerReference, {
    onSuccess,
    onError,
  })

  return { remove, ...rest }
}
